// extracted by mini-css-extract-plugin
export default {"root":"State_root__+O7Hq","dashboardPanel":"State_dashboardPanel__fJfNY","title":"State_title__bD8UN","text":"State_text__-r1jM","icon":"State_icon__xq8ho"};